import _ from 'lodash';
import { transformForEditing } from 'legacy/src/components/content/transformations';

export default function migrateNode(node) {
  if (!node) {
    return node;
  }
  if (node.text !== undefined && node.text === '') {
    return;
  }
  // Handle old, non-ProseMirror titles.
  if (
    node.title &&
    (node.type === 'composite/quiz' || node.type.startsWith('questions/'))
  ) {
    try {
      node.title = JSON.parse(node.title);
    } catch (e) {
      // Nothing to do here.
    }
  }

  if (node.type === 'amItem') {
    let item = node.attrs;
    if (!item.content) {
      item = {
        type: item.type,
        content: _.omit(item, 'type'),
      };
    }
    node = { ...node, attrs: transformForEditing(item) };
  }

  if (node.styles) {
    return {
      ..._.omit(node, 'styles'),
      marks: node.styles.map((s) => ({
        ..._.omit(s, 'type'),
        _: s.type,
      })),
    };
  }

  if (node.marks) {
    return { ...node, marks: node.marks.map((m) => (m._ ? m : { _: m })) };
  }

  /*
  "Styleable" lists used to be stored in the following format

  ```
  {
    "type": "styleable_list",
    "attrs": {
      "style": 'lower-roman',
      "order": "1"
    },
    "content": [...]
  }
  ```

  But we switched to multiple node types

  ```
  {
    "type": "lower_roman_list",
    "content": [...]
  }
  ```

  */

  if (node.type === 'styleable_list') {
    return {
      type:
        node.attrs.style && node.attrs.style !== 'decimal'
          ? `${node.attrs.style.replace('-', '_')}_list`
          : 'ordered_list',
      content: node.content.map(migrateNode),
    };
  }

  if (node.content) {
    return {
      ...node,
      content: node.content.map(migrateNode).filter((n) => n !== undefined),
    };
  }

  return node;
}
